module.exports = __webpack_public_path__ + "media/images/country_flags/sc-e9800c8e80de79369520ccef7c6037ea.png";